import BackendService, {
  CloneFundOpportunityRequest,
  CloneMode,
} from '../../../services/admin/BackendService';
import { parseCloneErrorMessage } from './cloneErrorUtils';
import { buildFundOpportunitySubmitPayload } from './formSubmitUtils';
import { FundOpportunityAdminFormData } from './types';

export async function fetchFundInvestmentData(fundOpportunityId: string) {
  return new BackendService().getFundInvestmentData(fundOpportunityId);
}

export async function addAllCandidatesForFund(fundOpportunityId: string) {
  return new BackendService().addAllCandidates(fundOpportunityId);
}

export async function updateFundOpportunityDetails(
  fundOpportunityId: string,
  formData: FundOpportunityAdminFormData,
) {
  return new BackendService().updateFundOpportunity(
    fundOpportunityId,
    buildFundOpportunitySubmitPayload(formData),
  );
}

export async function uploadIrrCsv(fundOpportunityId: string, file: File) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', file.name);
  return new BackendService().submitIRRUpdateCsv(fundOpportunityId, formData);
}

export async function deleteFundOpportunityRecord(fundOpportunityId: string, force: boolean) {
  return new BackendService().deleteFundOpportunity(fundOpportunityId, force);
}

export async function cloneFundOpportunityRecord(
  fundOpportunityId: string,
  mode: CloneMode,
  newName: string,
  destinationExternalId?: string,
) {
  const request: CloneFundOpportunityRequest = {
    mode,
    newName,
    destinationExternalId,
  };
  return new BackendService().cloneFundOpportunity(fundOpportunityId, request);
}

export { parseCloneErrorMessage };
